import AuthenticatedController from './AuthenticatedController';
import * as APIRoutes from '@mm/api-routes';
import * as queryString from 'query-string';
import {
  CtmAnalyticsQuery,
  queryRangeDateFormat,
} from '../model/CtmAnalyticsModel';

export class CtmInsightsController extends AuthenticatedController {
  static retrieve(botId: number, query: CtmAnalyticsQuery) {
    const q = queryString.stringify(
      {
        query: query.query,
        next: query.token,
        parent_id: `act_${query.parentId}`,
        'range[since]': query.range.since.format(queryRangeDateFormat),
        'range[until]': query.range.until.format(queryRangeDateFormat),
      },
      { arrayFormat: 'bracket' },
    );
    return super.get(APIRoutes.CTM_INSIGHTS(botId, q));
  }
}
